module.exports = __webpack_public_path__ + "static/winter4-55cf33f34e4c4fdf709030567bb8dc27.jpg";